import { ACTIONS } from "../constants/actions";

export default (state = { show: false, message: "" }, action) => {
  switch (action.type) {
    case ACTIONS.SET_ERROR:
      return { ...state, ...action.payload }
    default:
      return state
  }
}